module.exports = __webpack_public_path__ + "img/ueber-uns-v3.9e54349d.jpg";